import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AddTgPageData, TgPage } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const addTgPage = (data: AddTgPageData): Promise<{ page: TgPage }> => {
  return axios.put(`/telegram/pages`, data);
};

type AddTgPageOptions = {
  config?: MutationConfig<typeof addTgPage>;
};

const TOAST_ID = 'add-tg-page';

export function useAddTgPage({ config = {} }: AddTgPageOptions = {}) {
  return useMutation({
    ...config,
    onMutate(...args) {
      toasts.loadingToast.loading(TOAST_ID);
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      toasts.loadingToast.success(TOAST_ID);
      queryClient.invalidateQueries(['pages']);
      config.onSuccess?.(...args);
    },
    onError(error: AxiosError<{ error: string }>, ...args) {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      config.onError?.(error, ...args);
    },
    mutationFn: addTgPage,
  });
}
